import { render, staticRenderFns } from "./EditMultiPages.vue?vue&type=template&id=4f036c6a&"
import script from "./EditMultiPages.vue?vue&type=script&lang=js&"
export * from "./EditMultiPages.vue?vue&type=script&lang=js&"
import style0 from "./EditMultiPages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports